const csvImageheaders = [
    {
      key: "_id",
      label: "ID",
      color: "green",
    },
    {
      key: "imagUrl",
      label: "Image URL",
      color: "",
    },
    {
        key: "imageName",
        label: "Image Name",
        color: "",
      },
    {
      key: "status",
      label: "Status",
      color: "",
    },
    {
      key: "tags",
      label: "Tags",
      color: "",
    },
    {
      key: "format",
      label: "Format",
      color: "",
    },
    {
        key:"width",
        label: "Width",
    },
    {
        key:"height",
        label: "Height",
    }
  ];

export default csvImageheaders;